
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import debounce from "debounce";
import SimpleDialog from "@/components/SimpleDialog.vue";
import CustomerSuccessAddCompanyModal from "@/components/customerSuccess/CustomerSuccessAddCompanyModal.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";
import { CUSTOMER_SUCCESS_TYPE } from "@/utils/customerSuccess";

@Component({
    components: {
        SimpleDialog,
        CustomerSuccessAddCompanyModal,
    },
})
export default class CustomerSuccessCompaniesTab extends Vue {

    @Prop({ default: null })
    public userId: number;

    @Watch("search")
    public handlerSearch = debounce(this.searchCompanies, 500);

    private companies: object[] = [];
    private headers: object[] = [
        { value: "companyName", sortable: false },
        { value: "master", sortable: false },
        { value: "type", sortable: false },
        { value: "action", sortable: false },
    ];
    private loading: boolean = false;
    private search: string = "";
    private addCompanyDialog: boolean = false;
    private removedCompany: any = null;
    private removeDialog: boolean = false;
    private removing: boolean = false;
    private updatingCompanyId: number | null = null;

    get typeItems(): Array<{ text: string, value: string }> {
        return Object.values(CUSTOMER_SUCCESS_TYPE).map((type) => ({
            text: this.$t(`customerSuccess.type.${type}`).toString(),
            value: type,
        }));
    }

    private pagination: any = {
        page: 1,
        itemsPerPage: 10,
        totalItems: 10,
    };

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    @Watch("pagination", { deep: true })
    public handlerPagination(val, oldVal) {
        if (val.page !== oldVal.page || val.itemsPerPage !== oldVal.itemsPerPage) {
            this.getCompanies();
        }
    }

    private mounted() {
        this.getCompanies();
    }

    private searchCompanies() {
        if (this.pagination.page !== 1) {
            this.pagination.page = 1;
        } else {
            this.getCompanies();
        }
    }

    private getCompanies() {
        this.loading = true;
        return this.$store.dispatch("admin/customerSuccess/readCompanies", {
            userId: this.userId,
            query: { ...this.pagination, search: this.search },
        }).then((res) => {
            this.companies = res.rows;
            this.pagination.totalItems = res.count;
        }).finally(() => {
            this.loading = false;
        });
    }

    private updateType(item, newType: string): void {
        if (newType === item.type) {
            return;
        }
        this.updatingCompanyId = item.companyId;
        this.$store.dispatch("admin/customerSuccess/updateCompanyType", {
            userId: this.userId,
            companyId: item.companyId,
            type: newType,
        }).then(() => {
            item.type = newType;
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.updatingCompanyId = null;
        });
    }

    private openRemoveDialog(item): void {
        this.removedCompany = item;
        this.removeDialog = true;
    }

    private closeRemoveDialog(): void {
        this.removedCompany = null;
        this.removeDialog = false;
    }

    private removeCompany(): void {
        this.removing = true;
        this.$store.dispatch("admin/customerSuccess/removeCompany", {
            userId: this.userId,
            companyId: this.removedCompany.companyId,
        }).then(() => {
            this.closeRemoveDialog();
            this.getCompanies();
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.removing = false;
        });
    }
}
